/**
 * wyvio-ui · Chip, Avatar, Dot
 * ────────────────────────────
 * Micro-composants d'accompagnement.
 */

const T = {
  neutral:
    "bg-[#F3F4F6] dark:bg-[#1A1A1A] text-[#374151] dark:text-[#A3A3A3]",
  accent:
    "bg-[#F3FCE1] dark:bg-[#1F2A0A] text-[#4a6b0f] dark:text-[#C8FF2F]",
  dark:
    "bg-[#0A0A0A] dark:bg-white text-white dark:text-[#0A0A0A]",
  danger:
    "bg-[#FEE2E2] dark:bg-[#3B0F0F] text-[#991B1B] dark:text-[#FCA5A5]",
  warn:
    "bg-[#FEF3C7] dark:bg-[#3A2A0A] text-[#92400E] dark:text-[#FCD34D]",
};

export const Chip = ({ tone = "neutral", size = "md", uppercase = false, className = "", children, ...rest }) => (
  <span
    className={[
      "inline-flex items-center gap-1 rounded-full whitespace-nowrap font-semibold",
      size === "sm" ? "h-6 px-2 text-[10.5px]" : "h-8 px-3 text-[11.5px]",
      uppercase ? "uppercase tracking-wider" : "",
      T[tone] || T.neutral,
      className,
    ].join(" ")}
    {...rest}
  >
    {children}
  </span>
);

export const StatusDot = ({ tone = "neutral", className = "" }) => {
  const c = {
    accent: "bg-[#C8FF2F]",
    danger: "bg-[#EF4444]",
    warn: "bg-[#F59E0B]",
    success: "bg-[#22C55E]",
    neutral: "bg-[#D1D5DB] dark:bg-[#3F3F3F]",
  }[tone] || "bg-[#D1D5DB]";
  return <span className={`h-1.5 w-1.5 rounded-full shrink-0 ${c} ${className}`} aria-hidden />;
};

const initialsOf = (name) =>
  (name || "").split(" ").map((s) => s[0]).slice(0, 2).join("").toUpperCase() || "•";

export const Avatar = ({ name, size = 8, className = "" }) => (
  <span
    aria-label={name || ""}
    className={[
      `h-${size} w-${size} rounded-full flex items-center justify-center shrink-0`,
      "bg-[#F7F8FA] dark:bg-[#1A1A1A]",
      "text-[10px] font-semibold text-[#6B7280] dark:text-[#A3A3A3]",
      "uppercase tracking-wide",
      className,
    ].join(" ")}
  >
    {initialsOf(name)}
  </span>
);
